var _excluded = ["tooltip", "disabled", "tooltipPlacement", "children", "gearsBtnContainerClass"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import classnames from 'classnames';
import React from 'react';
import Button from "../Button/Button";
import Tooltip from "./Tooltip";
var count = 0;

var getID = function getID() {
  return "tooltip-button-".concat(count++);
};

var TooltipButton = function TooltipButton(_ref) {
  var tooltip = _ref.tooltip,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$tooltipPlacement = _ref.tooltipPlacement,
      tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'top' : _ref$tooltipPlacement,
      children = _ref.children,
      gearsBtnContainerClass = _ref.gearsBtnContainerClass,
      props = _objectWithoutProperties(_ref, _excluded);

  var buttonIdRef = React.useRef("tooltip-button-".concat(getID()));
  var buttonId = buttonIdRef.current;
  var tooltipId = "tooltip-for-".concat(buttonId);
  var className = classnames('d-inline-block', gearsBtnContainerClass);
  return /*#__PURE__*/React.createElement(React.Fragment, null, tooltip && /*#__PURE__*/React.createElement(Tooltip, {
    id: tooltipId,
    placement: tooltipPlacement,
    target: buttonId
  }, tooltip), /*#__PURE__*/React.createElement("div", {
    tabIndex: disabled && tooltip ? 0 : -1,
    id: buttonId,
    className: className
  }, /*#__PURE__*/React.createElement(Button, _extends({
    "aria-describedby": tooltipId,
    disabled: disabled,
    style: {
      pointerEvents: disabled ? 'none' : 'auto'
    }
  }, props), children)));
};

TooltipButton.displayName = 'TooltipButton';
export default TooltipButton;